// @storybook-skip: internal section of LessonsHomeScreen; covered by its screen story
import { useTranslation } from "react-i18next";
import { Button, Text } from "react-native-paper";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { LessonListItem } from "./LessonListItem";
import type { Lesson } from "./types";

type Props = {
	title?: string;
	lessons: Lesson[];
	onLessonPress: (lesson: Lesson) => void;
	onViewAllPress: () => void;
};

export const AllLessonsSection = ({
	title,
	lessons,
	onLessonPress,
	onViewAllPress,
}: Props) => {
	const { t } = useTranslation();
	const { isMobile } = useDevice();

	if (!lessons.length) {
		return null;
	}

	return (
		<Box gap={16}>
			<Box paddingHorizontal={16}>
				<Text variant="titleLarge">{title ?? t("lessons.home.all.title")}</Text>
			</Box>
			<Box gap={16} paddingHorizontal={16}>
				{lessons.map((lesson) => (
					<LessonListItem
						key={lesson.id}
						lesson={lesson}
						onPress={onLessonPress}
					/>
				))}
			</Box>
			<Button
				mode="contained"
				onPress={onViewAllPress}
				style={{
					marginHorizontal: 16,
					alignSelf: isMobile ? "auto" : "flex-end",
				}}
			>
				{t("common.viewAll")}
			</Button>
		</Box>
	);
};
